module.exports = __webpack_public_path__ + "static/media/ss.7b6381e2.jpg";